; (function (inovestor, undefined) {
    inovestor.ms.technicalChart = inovestor.ms.technicalChart || {};

    inovestor.ms.technicalChart.config = {
        suggestCountryPreference: 'ca',
        suggestApiRelativeUrl: 'search/suggest?q={term}&maxResult=15&searchedFields=symbol,nameen&requestedFields=exchange,symbol,nameen&countryPreference={countryPreference}',
        quoteRelativeUrl: 'quotes?symbols={symbol},',
        dailyStockHistoricalRelativeUrl: 'technicalChartDatas/daily?symbols={symbol}&startDate={startDate}&endDate={endDate}',
        intradayStockHistoricalRelativeUrl: 'technicalChartDatas/intraday?symbols={symbol}',
    };
})(inovestor);


; (function ($, inovestor, undefined) {
    function ApiClient() {
        const apiDataCache = {}

        function makeApiRequestAsync(apiRelativeUrl) {
            var options = { type: 'GET', contentType: 'application/json', error: function (error) { throw new Error(`Market Insights request error: ${error.status}`) } };

            return inovestor.ms.core.ajaxApi(apiRelativeUrl, options).then(function (data) {
                if (!inovestor.ms.core.isNullOrUndefined(data)) {
                    if (data.requestStatus === 'invalidIdentifier') {
                        //plugin.invalidIdentifierHandler();
                        // TODO: Invalid identifier handler
                        return [];
                    }

                    return data;
                }
            });
        }

        this.getSuggestionsAsync = function (userInput) {
            var suggestApiRelativeUrl = inovestor.ms.core.stringFormat(inovestor.ms.technicalChart.config.suggestApiRelativeUrl, {
                term: userInput,
                countryPreference: inovestor.ms.technicalChart.config.suggestCountryPreference
            });

            if (userInput) {
                return makeApiRequestAsync(suggestApiRelativeUrl);
            }

            return $.when([]);
        }

        this.getStockQuoteAsync = function (symbol) {
            var apiRelativeUrl = inovestor.ms.core.stringFormat(inovestor.ms.technicalChart.config.quoteRelativeUrl, { symbol: symbol });
            return makeApiRequestAsync(apiRelativeUrl);
        }

        this.getStockHistoricalDataAsync = function (symbol) {
            const cacheKey = `getStockHistoricalData_${symbol}`
            let data = apiDataCache[cacheKey]
            
            if (!data) {
                var date = new Date();
                // Remove 10 years from the date
                date.setFullYear(date.getFullYear() - 10);
                // And add a couple days just to make sure we don't hit the 10 years limit
                date.setDate(date.getDate() + 2);
                var apiRelativeUrl = inovestor.ms.core.stringFormat(inovestor.ms.technicalChart.config.dailyStockHistoricalRelativeUrl, {
                    symbol: symbol,
                    startDate: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
                    endDate: ''
                });
                return makeApiRequestAsync(apiRelativeUrl).then(function (response) {
                    apiDataCache[cacheKey] = response;
                    return response;
                });
            }

            return $.when(data);
        }

        this.getStockIntradayDataAsync = function (symbol) {
            const cacheKey = `getStockIntradayData_${symbol}`
            let data = apiDataCache[cacheKey]

            if (!data) {
                var apiRelativeUrl = inovestor.ms.core.stringFormat(inovestor.ms.technicalChart.config.intradayStockHistoricalRelativeUrl, { symbol: symbol });
                return makeApiRequestAsync(apiRelativeUrl).then(function (response) {
                    apiDataCache[cacheKey] = response;
                    return response;
                });
            }

            return $.when(data);
        }
    }

    inovestor.ms.technicalChart.apiClient = new ApiClient();
})(inovestor.ms.libRef.jQuery, inovestor);

; (function ($, inovestor, undefined) {
    function DataFeed() {
        const configurationData = {
            supported_resolutions: ['1', '1D'],
            exchanges: [
                // {
                //     value: '',
                //     name: 'All',
                //     desc: 'All (desc)',
                // },
                // {
                //     value: 'XTSE',
                //     name: 'TSX',
                //     desc: 'TSX (desc)',
                // },
                // {
                //     value: 'XTSX',
                //     name: 'TSX Venture',
                //     desc: 'TSX Venture (desc)',
                // },
                // {
                //     value: 'XNYS',
                //     name: 'NYSE',
                //     desc: 'NYSE (desc)',
                // },
                // {
                //     value: 'XNAS',
                //     name: 'NASDAQ',
                //     desc: 'NASDAQ (desc)',
                // },
                // {
                //     value: 'XASE',
                //     name: 'AMEX',
                //     desc: 'AMEX (desc)',
                // },
            ],
            symbols_types: [
                // {
                //     name: 'All',
                //     value: '',
                // },
                // {
                //     name: 'Stock',
                //     value: 'stock',
                // },
                // {
                //     name: 'ETF',
                //     value: 'etf',
                // },
            ],
        };

        this.onReady = function (callback) {
            setTimeout(() => callback(configurationData));
        }

        this.searchSymbols = function (
            userInput,
            exchange,
            symbolType,
            onResultReadyCallback
        ) {
            inovestor.ms.technicalChart.apiClient.getSuggestionsAsync(userInput).then(function (data) {
                const symbols = []

                data.forEach((suggestion) => {
                    if (suggestion.category === 'stock' || suggestion.category === 'etf') {
                        symbols.push({
                            symbol: suggestion.ticker,
                            full_name: suggestion.symbol,
                            ticker: suggestion.symbol,
                            description: inovestor.ms.core.currentLanguage === 'fr' ? suggestion.nameFr : suggestion.nameEn,
                            exchange: suggestion.exchange,
                            type: suggestion.category,
                        })
                    }
                })

                onResultReadyCallback(symbols);
            });
        }

        this.resolveSymbol = function (
            symbolName,
            onSymbolResolvedCallback,
            onResolveErrorCallback
        ) {
            inovestor.ms.technicalChart.apiClient.getStockQuoteAsync(symbolName)
                .then(function (data) {
                    const quotes = data;

                    if (quotes.length === 1 && quotes[0].requestStatus === 'success') {
                        const quote = quotes[0];

                        const symbolInfo = {
                            ticker: quote.symbol,
                            name: `${quote.ticker} (${quote.exchange})`,
                            description: (inovestor.ms.core.currentLanguage === 'fr' ? quote.nameFr : quote.nameEn).replace(/'/g, "’"),
                            type: 'stock', // TODO: Get type. Also use suggestions' type to call the good getStockQuote
                            session: '0930-1600',
                            timezone: 'America/Toronto',
                            exchange: quote.exchange,
                            minmov: 1,
                            pricescale: 100,
                            has_intraday: true,
                            intraday_multipliers: ['1'],
                            visible_plots_set: 'ohlcv',
                            has_weekly_and_monthly: false,
                            supported_resolutions: configurationData.supported_resolutions,
                            volume_precision: 2,
                            // Due to a bug in the current code base, we can't set endofday if we want time_frames (which we do)
                            // So streaming it is.
                            // Ref: https://github.com/tradingview/charting_library/issues/3945
                            //data_status: 'endofday',
                            data_status: 'streaming',
                        };

                        onSymbolResolvedCallback(symbolInfo);
                    } else {
                        onResolveErrorCallback(`Symbol '${symbolName}'not found`)
                    }
                })
                .fail(function (error) {
                    onResolveErrorCallback('An error occurred')
                });;
        }

        this.getBars = function (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) {
            const { from, to, countBack, firstDataRequest } = periodParams;

            // const urlParameters = {
            //     symbols: parsedSymbol.exchange,
            //     toTs: to,
            //     limit: 2000,
            // };
            // const query = Object.keys(urlParameters)
            //     .map(name => `${name}=${encodeURIComponent(urlParameters[name])}`)
            //         .join('&');
            try {
                const apiTask = resolution === '1'
                    ? inovestor.ms.technicalChart.apiClient.getStockIntradayDataAsync(symbolInfo.ticker)
                    : inovestor.ms.technicalChart.apiClient.getStockHistoricalDataAsync(symbolInfo.ticker);

                apiTask.then(function (apiResponse) {
                    const historicalDatas = apiResponse;

                    if (historicalDatas.length === 0 || historicalDatas[0].requestStatus !== 'success') {
                        // "noData" should be set if there is no data in the requested period.
                        onHistoryCallback([], { noData: true });
                        return;
                    }

                    const data = historicalDatas[0];
                    let bars = [];

                    const dateFieldIndex = data.fields.indexOf('date');
                    const openFieldIndex = data.fields.indexOf('open');
                    const highFieldIndex = data.fields.indexOf('high');
                    const lowFieldIndex = data.fields.indexOf('low');
                    const closeFieldIndex = data.fields.indexOf('close');
                    const volumeFieldIndex = data.fields.indexOf('volume');

                    // Start from the end of our dataset so we can add exactly how much bars are needed
                    let count = 0;
                    for (let i = data.datas.length - 1; i >= 0; i--) {
                        const bar = data.datas[i];
                        const date = new Date(bar[dateFieldIndex]);
                        const unixTimestamp = date.getTime();

                        if (count < countBack && unixTimestamp / 1000 < to) {
                            bars = [...bars, {
                                time: unixTimestamp,
                                low: bar[lowFieldIndex],
                                high: bar[highFieldIndex],
                                open: bar[openFieldIndex],
                                close: bar[closeFieldIndex],
                                volume: bar[volumeFieldIndex],
                            }];
                            ++count;
                        }
                    }

                    // Reverse the data array so newer dates are at the start of the array
                    bars = bars.reverse();

                    if (bars.length == 0) {
                        // If all bars are filtered out, return noData
                        onHistoryCallback([], { noData: true });
                    } else {
                        onHistoryCallback(bars, { noData: false });
                    }
                });

            } catch (error) {
                onErrorCallback(error);
            }
        }

        this.subscribeBars = function (symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback) {
        }

        this.unsubscribeBars = function (subscriberUID) {
        }
    }

    inovestor.ms.technicalChart.dataFeed = new DataFeed();
})(inovestor.ms.libRef.jQuery, inovestor);
; (function ($, inovestor, undefined) {

    // Create defaults parameters to pass to TradingView widget constructor.

    inovestor.ms.technicalChart.defaults = {
        interval: '1D',
        datafeed: inovestor.ms.technicalChart.dataFeed,
        timezone: 'America/Toronto',
        symbol_search_request_delay: 350,
        fullscreen: false,
        autosize: true,
        disabled_features: ['header_screenshot'],
        time_frames: [
            { text: "1d", resolution: "1", description: "1 Day" },
            { text: "1m", resolution: "1D", description: "1 Month" },
            { text: "3m", resolution: "1D", description: "3 Months" },
            { text: "6m", resolution: "1D", description: "6 Months" },
            { text: "1y", resolution: "1D", description: "1 Year" },
            { text: "5y", resolution: "1D", description: "5 Years" },
            { text: "10y", resolution: "1D", description: "10 Years" },
        ]
    }

})(inovestor.ms.libRef.jQuery, inovestor);